import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.classList.add("needs-validation");
    this.element.setAttribute("novalidate", true);
  }

  validate(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();

      this.element.reportValidity();
    }

    this.element.classList.add("was-validated");
  }
}
